import { getAiConversionQualification } from '@/api';
import store from '@/store';

/** 任务建单成功后检查常规算力弹窗资格。 */
export async function checkAiRegularPopup() {
  try {
    const res = await getAiConversionQualification();
    if (res?.status === 200 && res?.data?.show_regular_popup === true) {
      store.dispatch({ type: 'app/setAiRegularPopupVisible', payload: true });
    }
  } catch {
    // 资格检查失败不影响已创建的任务
  }
}

/** 弹窗完成展示后的数据刷新，只请求接口，不改变弹窗显示状态。 */
export async function refreshAiConversionQualification() {
  try {
    await getAiConversionQualification();
  } catch {
    // 刷新失败不影响弹窗关闭和充值流程
  }
}

export default checkAiRegularPopup;
